import { render, staticRenderFns } from "./ServiceShop.vue?vue&type=template&id=78dc1aec"
import script from "./ServiceShop.vue?vue&type=script&lang=js"
export * from "./ServiceShop.vue?vue&type=script&lang=js"
import style0 from "./ServiceShop.vue?vue&type=style&index=0&id=78dc1aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports